import React from "react";
import { Stack } from "~/components/Stack/Stack";
import { Button } from "../Button/Button";
import { Form } from "../Form/Form";
import { TextField } from "../TextField/TextField";
import { Text } from "../Text/Text";

export interface VoucherCodeFormProps {
  voucherCode: string;
  onCodeChange: (voucherCode: string) => void;
  onSubmit: (voucherCode: string) => void;
}

export default function VoucherCodeForm({
  voucherCode,
  onCodeChange,
  onSubmit,
}: VoucherCodeFormProps): React.ReactElement {
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    // not sure why this is here. copied form existing implementation
    if (!event.target) return;

    const formData = new FormData(event.target as HTMLFormElement);
    onSubmit(formData.get("code") as string);
  };
  return (
    <Form onSubmit={handleSubmit}>
      <Stack space="8">
        <Text font="accent" size="large" weight="strong">
          Promo Code
        </Text>
        <TextField
          name="code"
          value={voucherCode}
          autoComplete="off"
          required
          onChange={(value) => onCodeChange(value)}
        />
        <Button type="submit" primary>
          Apply
        </Button>
      </Stack>
    </Form>
  );
}
